import { useEffect, useState } from 'react';
import { api } from '@/lib/api';
import { Flame, X } from 'lucide-react';

export default function StreakBanner() {
  const [status, setStatus] = useState(null);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get('/streak/status');
        setStatus(data);
        if (data.at_risk) tryWebPush(data.streak_days);
      } catch { /* ignore */ }
    })();
  }, []);

  const tryWebPush = async (days) => {
    try {
      if (!('Notification' in window)) return;
      const already = sessionStorage.getItem('streak_push_shown');
      if (already) return;
      let perm = Notification.permission;
      if (perm === 'default') perm = await Notification.requestPermission();
      if (perm === 'granted') {
        new Notification('Maestro · ta série est en jeu', {
          body: `Tu as ${days} jour${days > 1 ? 's' : ''} de pratique d'affilée. Une petite session ce soir ?`,
          icon: '/favicon.ico',
        });
        sessionStorage.setItem('streak_push_shown', '1');
      }
    } catch { /* ignore */ }
  };

  if (!status?.at_risk || dismissed) return null;

  return (
    <div
      data-testid="streak-banner"
      className="mb-6 rounded-2xl border border-orange-800/60 bg-gradient-to-br from-orange-950/60 to-transparent p-5 flex items-center gap-4"
    >
      <Flame size={32} className="text-orange-400 shrink-0" />
      <div className="flex-1">
        <div className="font-display text-2xl">Ne casse pas ta série de {status.streak_days} j</div>
        <div className="text-stone-300 text-sm">Une petite session aujourd'hui et tu gardes ta flamme allumée.</div>
      </div>
      <button data-testid="streak-banner-dismiss" onClick={() => setDismissed(true)} className="text-stone-400 hover:text-stone-200 p-2">
        <X size={16} />
      </button>
    </div>
  );
}
